// apps/web/src/lib/painel/home/polaridade.ts — Fase 17.8, Plano 06 (D-05; UI-SPEC U-04, tendência do kv de apoio).
// Decide, por função pura, se uma variação é boa ou ruim para quem lê: a polaridade vem do contrato de dados
// (`Comparacao.polaridade`), nunca do componente. Variação nula ou 'NEUTRA' não é nem boa nem ruim.

import type { Comparacao } from '@pieltec/contracts';

export type TomDaTendencia = 'favoravel' | 'desfavoravel' | 'neutra';

/** Variação (já arredondada na API, em pontos percentuais) contra a janela anterior, lida pela polaridade da métrica. */
export function tomDaTendencia(variacao: number, polaridade: Comparacao['polaridade']): TomDaTendencia {
  if (!Number.isFinite(variacao) || polaridade === 'NEUTRA') return 'neutra';
  const arredondada = Math.round(variacao * 10) / 10;
  if (arredondada === 0) return 'neutra';
  const subiu = arredondada > 0;
  return subiu === (polaridade === 'SUBIR_E_BOM') ? 'favoravel' : 'desfavoravel';
}
